import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'material_list_page' */ './MaterialListPage'),
);
